// Builds the storefront product URL for the Reviews list's "Related Product"
// link. The reviews API's `product_permalink` field is unreliable/always
// empty, so the URL is composed client-side from the active store's
// `storeUrl` (see usePantryStore) plus the review row's `productSlug`
// (see MINE-0005).
export function buildProductUrl(storeUrl: string | undefined, productSlug: string | undefined): string {
  if (!storeUrl || !productSlug) return ''
  const base = storeUrl.endsWith('/') ? storeUrl.slice(0, -1) : storeUrl
  return `${base}/products/${productSlug}`
}
